/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { preparePaginationData } from "../constant/common";
import {
  getAllManagers,
  getOneManager,
  baneManager,
  addManagerAction,
} from "../services/managers";

const initialState = {
  allManagers: {},
  managerProfile: {},
};

const managers = createSlice({
  name: "mnagers",
  initialState,
  reducers: {
    setManagers(state, action) {
      state.allManagers = action.payload.data;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllManagers.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(getAllManagers.fulfilled, (state, action) => {
      state.loading = false;
      let data = preparePaginationData(action.payload.data);
      state.allManagers = data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(getAllManagers.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getOneManager.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(getOneManager.fulfilled, (state, action) => {
      state.loading = false;
      state.managerProfile = action.payload.data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(getOneManager.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(baneManager.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(baneManager.fulfilled, (state, action) => {
      state.loading = false;
      // state.managerProfile = action.payload.data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(baneManager.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addManagerAction.pending, (state, action) => {
      state.loading = true;
    });
    //success
    builder.addCase(addManagerAction.fulfilled, (state, action) => {
      state.loading = false;
      // state.managerProfile = action.payload.data;
      state.success = action.payload.data.status;
    });
    //reject
    builder.addCase(addManagerAction.rejected, (state, action) => {
      state.loading = false;
    });
    //get one client
    //pending
  },
});
export default managers.reducer;
export const { setManagers } = managers.actions;
